const Vr4 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-4/PNG%20n.4/3d%20%204-4/publish%204-4/`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 4 Tour"
        ></iframe>
      </div>
    );
};

export default Vr4;
